module.exports = __webpack_public_path__ + "media/images/Login_Welcome-2a422a48.png";